import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cx } from '../../lib/util/cx';

/** Port of the DS `Checkbox`: 16px native box with a brown accent, 8px gap, muted label. */
export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: ReactNode;
  align?: 'center' | 'start';
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, align = 'center', disabled, className, ...rest },
  ref,
) {
  return (
    <label
      className={cx(
        'flex select-none gap-2 font-body',
        align === 'start' ? 'items-start' : 'items-center',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className,
      )}
    >
      <input
        ref={ref}
        type="checkbox"
        disabled={disabled}
        className={cx('h-4 w-4 shrink-0 cursor-[inherit] accent-[var(--hp-brown)]', align === 'start' && 'mt-0.5')}
        {...rest}
      />
      {label && <span className="text-sm leading-[1.45] text-muted">{label}</span>}
    </label>
  );
});
